import { useState } from "react";
import { clubApi } from "../api/club.service";

export const useUpdateStatus = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (id: string, is_active: boolean) => {
    try {
      setLoading(true);

      const response: any = await clubApi.updateStatus(id, is_active);

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Edit club status failed:", err);

      return {
        success: false,
        message: err?.response?.data?.error?.message_vi || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
